var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 0.533203H1.92857C0.867867 0.533203 0 1.41856 0 2.51535V9.12904H18V2.51535C18 1.41856 17.1321 0.533203 16.0714 0.533203ZM5.44505 7.09404C5.163 7.2361 4.80139 7.2361 4.51934 7.09404C2.89292 6.32761 2.75147 4.82774 2.76435 4.21333C2.73381 3.34119 3.8548 2.97863 4.42936 2.60778C5.12204 2.13207 6.01883 2.92493 6.61507 3.22885C7.71838 3.86891 7.25951 6.25827 5.44505 7.09404ZM14.593 6.69102H9.05801C8.21829 6.6935 8.21425 5.37206 9.05801 5.36959H14.593C15.4367 5.38528 15.4383 6.67863 14.593 6.69102ZM14.593 4.28602C14.5415 4.28271 9.03456 4.2885 9.05801 4.28602C8.21748 4.28354 8.21506 2.96706 9.05801 2.96459H14.593C15.4359 2.98028 15.4391 4.26951 14.593 4.28602Z",
    fill: "#373E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4502V11.1704C0 12.2671 0.867867 13.1525 1.92857 13.1525H16.0714C17.1321 13.1525 18 12.2671 18 11.1704V10.4502H0Z",
    fill: "#373E51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0501 4.33888C4.05653 4.84102 4.23653 5.47531 4.98223 5.85852C5.72795 5.47531 5.90795 4.84102 5.91437 4.33888L4.98223 3.80371L4.0501 4.33888Z",
    fill: "#373E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.7741fb9bc78b56c05f9815d181e5a7c0.svg";
export { ForwardRef as ReactComponent };